export default {
	personal_website_builder: 'เครื่องมือช่วยสร้างเว็บไซต์ส่วนตัว',
	successful: 'สำเร็จแล้ว!',
	link_copied: 'คัดลอกลิงค์แล้ว',
	edit_url: 'แก้ไข URL',
	use_own_domain: 'ฉันสามารถตั้งชื่อโดเมนสำหรับเว็บไซต์นี้ได้หรือไม่?',
	yes_use_own_domain:
		'ได้ คุณสามารถตั้งชื่อโดเมนสำหรับเว็บไซต์นี้ได้ หากคุณต้องการตั้งชื่อโดเมนเองโปรดทำตามขั้นตอนใน',
	following_link: 'ลิงค์นี้',
	save: 'บันทึก',
	get_started: 'เริ่มต้น',
	welcome_pwb: 'ยินดีต้อนรับเข้าสู่เครื่องมือช่วยสร้างเว็บไซต์ส่วนตัว!',
	few_steps_closer_launch:
		'เพิ่มประสบการณ์การสร้างเว็บไซต์ของคุณเองไปอีกระดับ พร้อมช่วยสร้างเว็บไซต์อย่างมืออาชีพอย่างง่ายดายเพียงแค่ไม่กี่ขั้นตอน!',
	choose_subdomain: 'เลือกซับโดเมน',
	begin_website_setup_url: 'เริ่มต้นด้วยการตั้งเว็บไซต์ URL ของคุณ',
	can_use_own_domain: 'ฉันสามารถตั้งชื่อโดเมนสำหรับเว็บไซต์นี้ได้หรือไม่?',
	update_profile: 'อัปโหลด',
	update_profile_desc:
		'สิ่งแรกที่คุณอยากจะให้ผู้เข้าชมเว็บไซต์ของคุณเห็น ยกตัวอย่างเช่น การแนะนำตัวเอง สิ่งที่คุณทำ แรงบันดาลใจ เป็นต้น',
	avatar: 'รูปภาพ',
	story: 'เรื่องราวของคุณ',
	short_bio: 'เขียนข้อความสั้นๆเกี่ยวกับคุณ',
	your_social_information: 'ข้อมูลด้านโซเชียลของคุณ',
	your_social_information_desc:
		'เพิ่มข้อมูลการติดต่อเพื่อให้ผู้เข้าชมเว็บไซต์สามารถติดต่อคุณได้ รวมถึงข้อมูลโซเชียลมีเดียอื่นๆ',
	contact: 'ติดต่อ',
	phone_number: 'เบอร์โทรศัพท์',
	social: 'สื่อสังคมออนไลน์',
	customize_seo_desc:
		'ปรับการตั้งค่า Search Engine Optimization (SEO) สำหรับเว็บเพจเพื่อช่วยในการค้นหาเว็บไซต์ของคุณออนไลน์',
	page_title: 'หัวเรื่องของเว็บเพจ',
	user_financial_planning: '{userName} - การวางแผนการเงิน',
	describe_web_page_business: 'อธิบายเว็บเพจและธุรกิจของคุณด้วยอักขระประมาณ 55-60 ตัว',
	page_description: 'คำอธิบายเว็บเพจ',
	precise_desc_awesome_page: 'คำอธิบายรายละเอียดเว็บเพจของฉัน',
	page_summary_desc: 'สรุปเนื้อหาที่อยู่บนหน้าเว็บเพจด้วยอักขระประมาณ 155-160 ตัว',
	financial_planner: 'การวางแผนการเงิน',
	keywords: 'คีย์เวิร์ด',
	keywords_desc:
		'เพิ่มคีย์เวิร์ดที่เกี่ยวข้องที่หน้าเพจโดยแยกด้วยเครื่องหมายคอมม่าและเลือกคำที่เจาะจงที่สุด',
	snippet_image: 'รูปภาพ Snippet',
	image_not_appearing: 'ทำไมรูปไม่แสดงบนโซเชียลมีเดีย?',
	favicon: 'ไอคอน Favicon',
	achievements: 'รางวัลที่ได้รับ',
	achievements_desc:
		'เพื่อความน่าเชื่อถือให้แก่แบรนด์ของคุณโดยการเพิ่มรางวัลความสำเร็จเพื่อพิสูจน์ความเป็นมืออาชีพ',
	example: 'ตัวอย่างเช่น',
	title: 'หัวข้อ',
	from_to_date: '{fromYear} ถึง {toYear}',
	description: 'คำอธิบาย',
	add_item: 'เพิ่มรายการ',
	services: 'การบริการ',
	services_desc: 'เพิ่มการบริการมืออาชีพบางส่วนที่คุณให้บริการแก่ลูกค้า',
	will_writing: 'ร่างพินัยกรรม',
	will_writing_desc: 'ฉันเป็นนักวางแผนจัดการมรดก',
	next: 'ต่อไป',
	previous: 'ย้อนกลับ',
	submit: 'ยืนยัน',
	undo_last_action: 'เลิกทำ',
	redo_last_action: 'ทำซ้ำ',
	styles: 'รูปแบบ',
	styles_desc:
		'คุณสามารถปรับเปลี่ยนรูปแบบและหน้าตาของเว็บไซต์ในส่วนนี้ได้ การปรับเปลี่ยนนี้จะมีผลต่อทั้งเว็บไซต์',
	primary_color: 'โทนสีหลัก',
	header: 'หัวข้อเรื่อง',
	body: 'เนื้อหา',
	seo_desc: 'เว็บเพจของคุณจะมีหน้าตาดังต่อไปนี้บน Google Search, Social Media และ  Whatsapp',
	full_preview: 'แสดงแบบเต็ม',
	your_seo_preview: 'การแสดงผล SEO ของคุณ',
	seo_preview_desc:
		'เว็บไซต์ของคุณจะแสดงผลสองแบบ: แบบที่จะแสดงบนผลการค้นหา และ แบบที่จะแสดงเมื่อเว็บไซต์ของคุณถูกแชร์',
	search_engine: 'โปรแกรมค้นหา',
	social_media: 'โซเชียลมีเดีย',
	customise_seo_desc:
		'ปรับการตั้งค่า Search Engine Optimization (SEO) สำหรับเว็บเพจเพื่อช่วยในการค้นหาเว็บไซต์ของคุณออนไลน์',
	confirm: 'ยืนยัน',
	settings: 'ตั้งค่า',
	settings_desc: 'คุณสามารถเปลี่ยนเทมเพลตอื่นหรือรีเซ็ตเทมเพลตเป็นค่าเริ่มต้น',
	choose_new_template: 'เลือกเทมเพลตใหม่',
	reset_template: 'รีเซ็ตเทมเพลต',
	disclaimers: 'การปฏิเสธความรับผิด',
	other_settings: 'การตั้งค่าอื่นๆ',
	unpublish: 'ยกเลิกการเผยแพร่',
	are_you_sure: 'คุณแน่ใจหรือไม่?',
	are_you_sure_desc:
		'คุณแน่ใจว่าต้องการเปลี่ยนเทมเพลตใหม่หรือไม่? การเปลี่ยนแปลงที่ทำบนเทมเพลตปัจจุบันจะถูกบันทึกและจะโหลดใหม่ในครั้งต่อไปที่คุณเปลี่ยนเทมเพลต',
	yes: 'ตกลง',
	change_now: 'เปลี่ยนตอนนี้',
	reset_template_confirm_msg:
		'เมื่อทำการรีเซ็ต ข้อมูลทั้งหมดที่บันทึกไว้จะหายและไม่สามารถกู้คืนได้',
	yes_reset_now: 'ตกลง ซีเซ็ตตอนนี้',
	disclaimer_settings: 'การตั้งค่าข้อจำกัดความรับผิด',
	content_form_disclaimer: 'แบบฟอร์มเนื้อหาข้อจำกัดความรับผิด',
	content_form_disclaimer_desc:
		'โดยการทำเครื่องหมายในช่องที่กำหนด จะถือว่าคุณยินยอมให้ FIRSTNAMELASTNAME รวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลไปยัง GoalsMapper เพื่อวัตถุประสงค์ดังต่อไปนี้:',
	perform_holistic_review: 'เพื่อดำเนินการตรวจสอบภาพรวมของพอร์ตโฟลิโอทางการเงินของคุณ',
	send_marketing_information: 'ส่งข่าวสารข้อมูลการตลาดเกี่ยวกับสินค้าและบริการ',
	comply_laws:
		'ปฏิบัติตามกฎหมาย ข้อบังคับ หลักปฏิบัติ แนวทาง หรือกฎเกณฑ์ใดๆ ที่เกี่ยวข้อง หรือเพื่อร่วมมือกับข้อบังคับใช้ทางกฎหมายและการสอบสวนซึ่งดำเนินการโดยรัฐบาลและ/หรือหน่วยงานภาครัฐ',
	notify_promotions:
		'แจ้งให้ทราบเกี่ยวกับกิจกรรมทางการตลาด ความคิดริเริ่มและโปรโมชั่น การจับรางวัล แผนการเป็นสมาชิกและของรางวัล และโปรโมชั่นอื่นๆ',
	contact_information_submit_message:
		'รายละเอียดการติดต่อของคุณจะถูกส่งไปยัง FIRSTNAMELASTNAME ผ่านแพลตฟอร์มของ GoalsMapper ซึ่ง GoalsMapper เป็นซอฟต์แวร์การวางแผนทางการเงินของบุคคลที่สามที่ออกแบบมาเพื่อสร้างประสบการณ์การวางแผนทางการเงินร่วมกันระหว่างที่ปรึกษาทางการเงินและลูกค้า',
	proceed_if_agree_contact: 'โปรดดำเนินการต่อหากคุณยินยอมที่จะปฏิบัติตามจุดประสงค์ข้างต้น',
	widget_disclaimer: 'ชุดคำสั่งข้อจำกัดความรับผิด',
	consent_personal_data_collection:
		'ฉันยินยอมให้รวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ดังต่อไปนี้:',
	consent_personal_data_collection_1:
		'ก. ปฏิบัติตามภาระผูกพันในระหว่างหรือที่เกี่ยวข้องกับการจัดหาสินค้าและ/หรือบริการที่ถูกร้องขอ',
	consent_personal_data_collection_2:
		'ข. ส่งข้อมูลการตลาดเกี่ยวกับสินค้าหรือบริการ รวมถึงการแจ้งให้ทราบเกี่ยวกับกิจกรรมทางการตลาด การริเริ่มและโปรโมชั่น การจับรางวัล แผนการเป็นสมาชิกและรางวัล และโปรโมชั่นอื่นๆ',
	consent_personal_data_collection_3:
		'ค. ปฏิบัติตามกฎหมาย ข้อบังคับ หลักปฏิบัติ แนวทาง หรือกฎเกณฑ์ใดๆ ที่เกี่ยวข้อง หรือเพื่อช่วยเหลือในการบังคับใช้กฎหมายและการสอบสวนที่ดำเนินการโดยหน่วยงานของรัฐและ/หรือหน่วยงานภาครัฐ',
	consent_personal_data_collection_4: 'ง. วัตถุประสงค์อื่นใดที่ได้ให้ข้อมูล',
	clear_content: 'ล้างเนี้อหา',
	reset_disclaimer: 'รีเซ็ตค่าเริ่มต้นข้อจำกัดความรับผิด',
	facebook_pixel_desc:
		'Facebook Pixel คือรหัสโค้ดที่คุณวางบนเว็บไซต์ เพื่อรวบรวมข้อมูลที่ช่วยคุณติดตามบนสนทนาต่างๆ จากโฆษณา Facebook เพิ่มประสิทธิภาพโฆษณา สร้างกลุ่มเป้าหมายสำหรับโฆษณาในอนาคต และรีมาร์เก็ตไปยังผู้ที่ได้ดำเนินการบางอย่างบนเว็บไซต์ของคุณแล้ว',
	facebook_pixel_id: 'รหัส Facebook Pixel',
	how_to_get_fb_pixel: 'ฉันจะรับ Facebook Pixel ได้จากที่ไหน?',
	fb_pixel_desc: 'รหัส Pixel ควรถูกเพิ่มที่ส่วนหัวของเว็บไซต์',
	add_recaptch_here: 'เพิ่มคีย์ Recaptcha ที่นี่',
	how_to_get_recaptcha: 'ฉันจะรับคีย์ Recaptcha ได้อย่างไร?',
	add_google_analytics: 'เพิ่มคีย์ Google Analytics ที่นี่',
	unpublish_your_website: 'ยกเลิกการเผยแพร่เว็บไซต์',
	confirm_unpublish_website: 'คุณแน่ใจว่าต้องการยกเลิกการเผยแพร่เว็บไซต์?',
	unpublish_website_msg:
		'คุณแน่ใจว่าต้องการยกเลิกการเผยแพร่เว็บไซต์? <br />จะไม่สามารถเข้าที่อยู่ URL https://thomas-lee.planyourfuture.today ได้อีกเมื่อคุณยกเลิกการเผยแพร่เว็บไซต์',
	yes_unpublish_now: 'ตกลง ยกเลิกการเผยแพร่ตอนนี้',
	sections: 'ส่วนต่างๆ',
	drag_rearrange_sections: 'ลากและจัดเรียงลำดับส่วนของเว็บไซต์ใหม่',
	my_story: 'เรื่องราวของฉัน',
	my_services: 'การให้บริการ',
	my_achievements: 'รางวัลที่ได้รับ',
	videos: 'วิดีโอ',
	ebook: 'อีบุ๊ค',
	testimonials: 'คำรับรอง',
	tools: 'เครื่องมือ',
	edit: 'แก้ไข',
	configure: 'ปรับแต่ง',
	background: 'พื้นหลัง',
	configure_intro_page: 'ปรับแต่งหน้าแนะนำ',
	download_ebook: 'ดาวน์โหลดอีบุ๊ค',
	preview: 'แสดงตัวอย่าง',
	desktop: 'เดสก์ท็อป',
	tablet: 'แท็บเล็ต',
	mobile: 'โทรศัพท์',
	status: 'สถานะ',
	blank: 'ว่าง',
	launch: 'แสดงผล!',
	auto_save: 'การเปลี่ยนแปลงถูกบันทึกอัตโนมัติ',
	published: 'เผยแพร่แล้ว',
	published_on: 'เผยแพร่เมื่อ',
	last_updated_on: 'อัปเดตล่าสุด',
	researcher_author_speaker: 'นักวิจัย <br />นักเขียน และนักพูด',
	tagline: 'สร้างความแตกต่าง<br />ให้แก่<br />อนาคตทางการเงิน',
	tagline_desc:
		'เป้าหมายของฉันคือการได้ช่วยเหลือลูกค้าในการบรรลุเป้าหมายและอิสรภาพทางการเงิน รวมไปถึงสร้างความสัมพันธ์แบบมืออาชีพและเชื่อถือได้',
	about: 'เกี่ยวกับ',
	about_body:
		'ด้วยความหลงใหลในการเติมเต็มความหมายให้แก่อาชีพ ฉันได้เข้าร่วมอุตสหกรรมการบริการทางด้านการเงินเพื่อสร้างความแตกต่างให้กับชีวิตของผู้คน เพราะความเชี่ยวชาญด้านการวางแผนทางการเงิน ลูกค้ามากมายได้ปรับเปลี่ยนมุมมองด้านการบริหารการเงินหลังจากได้พูดคุยกับฉัน',
	service_subtitle:
		'งานประจำของฉันคือการช่วยเหลือด้านการวางแผนทางการเงินสามด้านหลักนั้นก็คือ การออม การป้องกันรักษา และการเพิ่มพูลเงิน!',
	service_body1:
		'ขั้นตอนแรกในการบริหารเงินอย่างมีประสิทธิภาพก็คือการสร้างนิสัยการออมเงินที่ถูกต้อง ยิ่งในสภาพแวดล้อมปัจจุบันที่ใครๆก็อยากซื้อของแบรนด์ดังราคาแพงแทนการเก็บออมเงินเพื่อเหตุการฉุกเฉินหรือเป้าหมายทางการเงิน ดังนั้นมาเรียนรู้กันว่าเราจะเริ่มเก็บเงินอย่างไรดีเพื่อให้ถึงเป้าหมายที่ตั้งไว้',
	protect: 'การป้องกัน',
	service_body2:
		'บางคนเข้าใจผิดว่าการมีประกันชีวิตที่ครอบคลุมหมายถึงจำนวนกรมธรรม์ที่เยอะ แต่ที่จริงแล้วการมีกรมธรรม์ที่เยอะไม่ได้หมายความว่าประกันชีวิตนั้นจะครอบคลุมได้อย่างทั่วถึง เรามาดูกันว่าคุณได้ทำประกันชีวิตไว้ครอบคลุมเพียงพอหรือไม่',
	grow: 'การเพิ่มพูล',
	service_body3:
		'พลังของดอกเบี้ยทบต้นนั้นมีอยู่จริงและยิ่งเริ่มเร็วยิ่งดี คนส่วนใหญ่เลือกที่จะหลีกเลี่ยงโดยการเก็บเงินไว้ในธนาคารเพราะคิดว่ามันน่าจะปลอดภัยแล้ว แต่อย่างไรก็ตามหากคุณต้องการที่จะเพิ่มพูลเงิน การฝากเงินในธนาคารอาจจะไม่ใช่ทางเลือกที่ดีที่สุด เรามาเรียนรู้วิธีการเพิ่มพูลการลงทุนผ่านการบริหารความเสี่ยงที่หลากหลาย',
	yours_free: 'โหลดฟรี:',
	ebook_desc:
		'แนวคิดด้านการเงินที่เข้าใจง่าย ที่ทุกคนก็สามารถนำไปปรับใช้เพื่อพัฒนาสถานการณ์ด้านการเงินได้ทันที!',
	download_ebook_btn: 'ดาวน์โหลดอีบุ๊คได้ฟรี',
	download_ebook_subtitle:
		'ปล: คู่มือเล่มนี้มีเพื่อให้เคล็ดลับและกลยุทธ์ในการวางแผนด้านการเงิน แต่สิ่งที่สำคัญที่สุดคือคุณต้องนำกลยุทธ์เหล่านี้ ไปปรับใช้ ขอให้ทุกท่านมีความสุขในการอ่าน!',
	financial_calculators: 'เครื่องคำนวณแผนทางการเงิน',
	financial_calculator: 'เครื่องคำนวณทางการเงิน',
	financial_calculators_short_desc: 'คุณสามารถปรับเปลี่ยนการแสดงวิดเจ็ตบนเว็บไซต์ตรงนี้ได้',
	financial_calculators_desc:
		'คุณสามารถปรับเปลี่ยนการแสดงวิดเจ็ตบนเว็บไชต์ได้โดยการแก้ไขตรงส่วนแก้ไขด้านล่างนี้',
	header_color: 'สีหัวข้อ',
	text_color: 'สีข้อความ',
	button_text_color: 'สีข้อความปุ่ม',
	button_background_color: 'สีพื้นหลังปุ่ม',
	widget: 'วิดเจ็ต',
	widget_desc:
		'เครื่องช่วยวางแผนทางการเงินแบบตอบโต้จะช่วยให้คุณดึงดูดลูกค้า และสามารถช่วยให้ลูกค้าของคุณเข้าใจได้อย่างรวดเร็วเกี่ยวกับเงินที่ต้องจ่ายและการเก็บเงิน/ลงทุนต่างๆจากเงินเก็บ ในขั้นตอนสุดท้ายลูกค้าจะได้รับข้อเสนอในการติดต่อกับคุณเพื่อรับคำปรึกษา โดยรายการชื่อลูกค้าจะถูกส่งไปที่อีเมลของคุณ',
	add_widgets: 'เพิ่มวิดเจ็ต',
	choose_widgets: 'ทำการเลือกวิดเจ็ตเพื่อเพิ่มลงในเว็บไซต์',
	coming_soon: 'กำลังมาเร็วๆนี้',
	education_calculator: 'เครื่องคำนวณการวางแผนด้านการศึกษา',
	education_calculator_desc: 'คำนวณค่าใช้จ่ายการศึกษาของลูกๆ ทั้งในประเทศและต่างประเทศ',
	retirement_calculator: 'เครื่องคำนวณการวางแผนการเกษียณอายุ',
	retirement_calculator_desc: 'คำนวณค่าใช้จ่ายสำหรับการเกษียณอายุของคุณ',
	insurance_calculator: 'เครื่องคำนวณการวางแผนประกันชีวิต',
	insurance_calculator_desc: 'คำนวณค่าใช้จ่ายการครอบคลุมของประกันชีวิต',
	message_successfully_sent: 'ข้อความของคุณได้ถูกส่งสำเร็จแล้ว',
	name: 'ชื่อ',
	name_required: 'จำเป็นต้องใส่ชื่อ',
	message: 'ข้อความ',
	message_here: 'ใส่ข้อความตรงนี้',
	footer_text:
		'ข้อมูลที่แสดงบนเว็บไซต์นี้เป็นข้อมูลทั่วไปและไม่ถือเป็นคำแนะนำทางการเงิน เว็บไซต์สามารถเปลี่ยนแปลงได้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า และไม่รับประกันความถูกต้องของข้อมูล รวมถึงข้อมูลที่ให้โดยบุคคลที่สาม ณ เวลาใดเวลาหนึ่งโดยเฉพาะ<br /><br />ผู้ใช้บริการต้องไม่อ้างอิงข้อมูลนี้ในการตัดสินใจทางการเงินหรือการลงทุน ก่อนตัดสินใจใดๆ ขอแนะนำให้ปรึกษาที่ปรึกษาทางการเงินมืออาชีพเพื่อพิจารณาวัตถุประสงค์การลงทุน สถานการณ์ทางการเงิน และความต้องการส่วนบุคคลโดยเฉพาะ<br /><br />เจ้าของเว็บไซต์นี้ไม่ได้ให้การรับประกันใด ๆ ด้านความถูกต้อง ความน่าเชื่อถือ หรือความสมบูรณ์ของข้อมูลที่มีอยู่ในเว็บไซต์นี้ เจ้าของเว็บไซต์นี้ไม่ยอมรับความรับผิดใด ๆ สำหรับข้อผิดพลาดหรือการละเว้นใด ๆ ในเว็บไซต์นี้หรือการสูญเสียหรือความเสียหายที่เกิดขึ้นโดยผู้รับหรือบุคคลอื่น<br /><br />เว้นแต่จะระบุไว้เป็นอย่างอื่น ข้อมูลที่ให้ไว้บนเว็บไซต์นี้มีลิขสิทธิ์ ผู้ใช้บริการไม่สามารถดัดแปลงหรือแก้ไขข้อมูลนี้ในทางใดทางหนึ่ง รวมทั้งลบประกาศลิขสิทธิ์นี้',
	main: 'หน้าหลัก',
	customize_tagline: 'คุณสามารถปรับเปลี่ยนการแสดงผลของสโลแกนได้จากตรงนี้',
	customize_tagline_desc:
		'คุณสามารถเปลี่ยนการแสดงผลของสโลแกนบนหน้าเว็บไซต์ได้จากการแก้ไขการตั้งค่าด้านล่าง',
	tagline_color: 'สีสโลแกน',
	story_desc: 'คุณสามารถปรับเปลี่ยนข้อมูลที่แสดงบนเว็บไซต์ได้จากตรงนี้',
	story_settings_desc:
		'คุณสามารถเปลี่ยนการแสดงผลของข้อมูลบนเว็บไซต์โดยการแก้ไขในการตั้งค่าด้านล่าง',
	your_services: 'การบริการ',
	your_services_desc:
		'คุณสามารถเปลี่ยนการแสดงผลของการบริการบนเว็บไซต์โดยการแก้ไขในการตั้งค่าด้านล่าง',
	my_achievements_desc:
		'รางวัลที่ภาคภูมิใจช่วยให้คุณโดดเด่นจากคู่แข่ง พร้อมทั้งแสดงให้เห็นว่าคุณเป็นผู้เชี่ยวชาญในด้านนี้',
	your_achievements: 'รางวัลที่ภาคภูมิใจของคุณ',
	your_achievements_desc:
		'คุณสามารถเปลี่ยนการแสดงผลของรางวัลที่ภาคภูมิใจบนเว็บไซต์โดยการแก้ไขในการตั้งค่าด้านล่าง',
	video: 'วีดีโอ',
	ebook_intro_page: 'หน้าแนะนำอีบุ๊ค!',
	ebook_intro_page_desc:
		'สามารถสร้างหน้าแนะนำของอีบุ๊คเพื่อช่วยให้ผู้อ่านรู้เกี่ยวกับคุณ ความน่าเชื่อถือต่างๆ และประสบการณ์ รวมไปถึงวิธีการที่คุณสามารถช่วยวางแผนตามความต้องการของผู้อ่าน',
	testimonials_desc:
		'คำแนะนำจากลูกค้าช่วยเพิ่มเนื้อหาให้กับเว็บไซต์ของคุณ และช่วยให้คุณมีความน่าเชื่อถือและน่าไว้วางใจสำหรับคนที่เข้ามาใช้บริการเป็นครั้งแรก',
	your_testimonials: 'คำแนะนำจากลูกค้าของคุณ',
	your_testimonials_desc:
		'คุณสามารถเปลี่ยนการแสดงผลของคำแนะนำจากลูกค้าบนเว็บไซต์โดยการแก้ไขในการตั้งค่าด้านล่าง<br />เพียงแค่รูปแบบของคำแนะนำจากลูกค้าจะถูกรวมอยู่ในส่วนนี้',
	height: 'ความสูง',
	testimonial_style: 'รูปแบบคำแนะนำจากลูกค้า',
	style: 'รูปแบบ',
	contact_desc:
		'เพิ่มลิงค์ไปที่หน้าเพจโซเชียลมีเดียของคุณและสร้างการสร้างแบรนด์ส่วนบุคคลสำหรับคุณเอง',
	receiving_email: 'อีเมลที่ใช้ *',
	contact_number: 'เบอร์ที่ติดต่อได้',
	social_media_links: 'ลิงค์โซเชียลมีเดีย',
	whatsapp_desc: 'e.g. +6501234567 หรือ https://wa.me/6501234567',
	telegram_desc: 'e.g. chanxing หรือ https://telegram.me/chanxing',
	appearance: 'การแสดงผล',
	social_media_icons_color: 'สีไอคอนโซเชียลมีเดีย',
	button_label: 'แถบปุ่มกด',
	set_background: 'ตั้งค่าพื้นหลัง',
	layout: 'เลย์เอาต์',
	begin: 'เริ่ม',
	richard_tan_testimonial:
		'ผมพึงพอใจกับการบริการเป็นอย่างมาก ทั่งได้รับประสบการณ์ที่ดีทีได้ทำงานร่วมกับผู้ให้คำปรึกษาทางด้านการเงินที่ให้ความสนใจกับความต้องการของลูกค้า สถานการ์ณและสิ่งที่ลูกค้าอยากได้ สิ่งที่ผมประทับใจมากที่สุดคือการให้คำปรึกษาโดยคำนึงถึงความรู้สึกของผมเป็นส่วนใหญ่ พร้อมความรู้ การวิเคราะห์และแนวทางการปฏิบัติที่สามารถเป็นไปได้ ความเป็นมืออาชีพและความใส่ใจทำให้ผมรู้สึกเชื่อใจและเคารพการบริการของ เป็นอย่างมาก ผมจะแนะนำการบริการของคุณให้แก่คืนอื่นในอนาคตอย่างแน่นอน',
	lily_jacob_testimonial:
		'ฉันรู้สึกประทับใจกับการให้คำปรึกษาของ ในการใช้โปรแกรมช่วยวางแผนทางด้านการเงินของฉันและผลกระทบจากสถานการ์ณต่างๆที่จะส่งผลต่อแผนทางการเงินในอนาคต นี่คือการบริการที่นักวางแผนทางการเงินควรมี ให้ชอบการบริการของ เป็นอย่างมากและแนะนำการบริการของเธอ',
	sam_ng_testimonial:
		"ฉันรู้สึก 'ชื่นชอบ' การให้คำปรึกษาของ เธอช่วยให้ฉันมองเห็นจุดอ่อนทางด้านการเงินของตัวเอง และเรื่องอื่นๆที่ฉันไม่เคยนึกถึงมาก่อน ฉันรู้สึกตกใจมากเมื่อพบว่าสถานการณ์ที่ไม่ได้คาดคิดสามารถส่งผลด้านการเงินได้ขนาดนี้",
	clinic_assistant: 'อาชีพผู้ช่วยวิจัย',
	army_officer: 'อาชีพทหาร',
	it_specialist: 'อาชีพผู้เชี่ยวชาญด้าน IT',
	plan: 'วางแผน',
	service_body4:
		'วางแผนอนาคตทางการเงินของคุณวันนี้! ทำความเข้าใจเป้าหมายทางการเงินของคุณให้ดีขึ้น และที่สำคัญที่สุดคือ การกำหนดงบประมาณทางการเงินที่เหมาะสมสำหรับเป้าหมายที่คุณต้องการในชีวิต เราทุกคนต้องการมีสิ่งที่ดีที่สุดในชีวิต แต่ในความเป็นจริง เราไม่สามารถมีทุกสิ่งได้ การตั้งเป้าหมายทางการเงินที่ถูกต้องก่อนเป็นกุญแจสำคัญในการตัดสินใจทางการเงินที่ถูกต้องสำหรับชีวิตของคุณ',
	select: 'เลือก',
	videos_desc: 'ที่นี่ คุณสามารถเปลี่ยนวิธีการแสดงวิดีโอของคุณบนเว็บไซต์ได้',
	e_g: 'เช่น.',
	ebook_personal_branding: 'สร้าง อีบุ๊ค การสร้างแบรนด์ส่วนตัวของคุณเอง',
	button: 'ปุ่ม',
	popup: 'ป๊อปอัพ',
	use_goalsmapper_ebook: 'ใช้ อีบุ๊ค ของ GoalsMapper',
	customize_ebook_intro_page: 'ปรับแต่งหน้าแนะนำ อีบุ๊ค',
	upload_image: 'อัพโหลดภาพ',
	change_image: 'เปลี่ยนภาพ',
	browse_unsplash: 'เรียกดูรูปภาพจาก Unsplash',
	set_color: 'ตั้งค่าสี',
	expected_image_size: 'ขนาดภาพที่ต้องการ',
	ok: 'โอเค',
	search: 'ค้นหา',
	your_videos_desc: 'คุณสามารถเปลี่ยนการแสดงผลของวิดีโอบนเว็บไซต์โดยการแก้ไขในการตั้งค่าด้านล่าง',
	columns: 'คอลัมน์',
	save_successful: 'บันทึกสำเร็จ',
	entity_saved: '{entity} ของคุณได้รับการบันทึกแล้ว',
	entity_saved_not_launched: 'บันทึก {entity} ของคุณแล้ว แต่ยังไม่ได้เปิดตัว',
	publish: 'ประกาศ',
	to_publish_latest_changes: 'เพื่อเผยแพร่การเปลี่ยนแปลงล่าสุด',
	to_make_it_visible: 'เพื่อให้ทุกคนมองเห็นได้',
	click: 'คลิก',
	website: 'เว็บไซต์',
	report_cover: 'ปกรายงาน',
	report: 'รายงาน',
	ebook_intro: 'แนะนำ อีบุ๊ค',
	preview_ebook: 'ดูตัวอย่างอีบุ๊ค',
	ebook_intro_text_left:
		'ไรอันเข้าร่วมปฏิบัติการให้คาปรึกษาทางการเงินในปี พ.ศ. 2550 และเชื่อมนว่าการวางแผนทางการเงิน ั่ สามารถช่วยสร้างความแตกต่างในชีวิตของผู้คนได้ ความเช่ือมนรวมถึงความหลงใหลน้ีเป็นส่วนช่วยให้ ั่ ประสบความส าเร็จในการเดินทางในฐานะท่ีปรึกษา ทางการเงิน<br /><br />หลังจากเข้าร่วมได้ไม่นาน เขาได้ให้ค าปรึกษาทางด้าน การเงินแก่ ลูกค้าหลายอาชีพ ชาวต่างชาติ และลูกค้า จากต่างประเทศจ านวนมาก จนถึงปจจุบันเขาได้ให้ ั ค าแนะน าทางการเงินแก่ลูกค้ามากกว่า 20 ประเทศทวั่ โลก<br /><br />ด้วยประสบการณ์ความรู้ในการให้บริการแก่ลูกค้าที่ดี ยิ่งเยี่ยม เขาได้รับการแต่งตั้งเป ็น ChFC ® /S และ CLU ® /S จากวิทยาลัยอเมริกันของบริการทางการเงิน และได้รับการรับรอง AEPP ® จาก Estate Planning Practitioners Ltd.',
	ebook_intro_text_right:
		'พร้อมประสบการณ์อันเชีHยวชาญ ไรอันได้จัดทําวิธีการ วางแผนทางการเงินทีHเน้นเป้าหมายและเป็นทีHรู้จักในชืHอการ วางแผนอนาคต เขาใช้แนวทางนี Oในการแนะนําลูกค้าและได้ รับคําชืHนชมมากมายเกีHยวกับวิธีการวางแผนทางการเงินทีH สามารถช่วยให้ลูกค้าบรรลุเป้าหมายทางการเงินทีHหลากหลาย<br /><br />ในปีพ.ศ. 2558 ไรอันได้ร่วมก่อตั Oง GoalsMapper ซึHงเป็น บริษัททีHมีวิสัยทัศน์ในการกําหนดแผนทางการเงินรูปแบบใหม่<br /><br />ในปีพ.ศ. 2559 เขาได้รับรางวัล Court of the Table อัน ทรงเกียรติและได้รับการจัดอันดับให้เป็นผู้ผลิต 1% แรก ในบริษัท และในปีพ.ศ. 2561 เขาประสบความสําเร็จใน การเป็นสมาชิกตลอดชีวิตของ MDRT เพียง 10 ปีหลังจาก เข้าร่วมในอุตสาหกรรมการเป็นทีHปรึกษาทางการเงิน',
	goals: 'อนาคต',
	mapping: 'การวางแผน',
	what_is_goalsmapping: '{MAPPING}{GOALS}คืออะไร?',
	what_is_gm_desc:
		"{GOALS}{MAPPING}เป็นขั'นตอนท,ีสร้างข'ึนเพ,ือช่วยพัฒนาแผนทางการเงินท,ีมีความเหมาะสมแต่ละรายบุคคล และสามารถรองรับเป้าหมายทางการเงินและสถานการณ์ได้หลายรูปแบบก่อนตัดสินใจปฏิบัติตามแนวทางท,ีวางไว้ ในขั'นตอน{GOALS}{MAPPING}จําเป็นต้องมีการระบุเป้าหมายทางการเงินทั'งหมด รวมทั'งทดสอบภายใต้สถานการณ์ต่างๆ เพ,ือให้แน่ใจว่าสามารถบรรลุเป้าหมายทางการเงินทั'งหมดโดยใช้ตัวช่วยการวางแผนทางการเงินต่างๆ เช่น ตั'งแต่การออมธนาคาร ประกันชีวิต ไปจนถึงการลงทุนต่างๆ ในคู่มือเล่มน'ี เราจะสํารวจแบบจําลองต่างๆ ของ {GOALS}{MAPPING}โดยประกอบด้วยแนวคิดพ'ืนฐานทางการเงินท,ีทุกคนสามารถนําไปปรับใชเพ,ือพัฒนาสถานการณ์ทางการเงินได้โดยทันที",
	gm_disclaimer_block:
		'GoalsMapper เป็นซอฟต์แวร์วางแผนทางการเงินของบุคคลทีCสามสําหรับทีCปรึกษาทางการเงิน ซึCงทีCปรึกษา ทางการเงินข้างต้นเป็นผู้ใช้ GoalsMapper และไม่ใช่ตัวแทนของ GoalsMapper Pte Ltd.',
	add_header_text: 'เพิ่มหัวข้อ',
	add_body_text: 'เพิ่มเนื้อหา',
	add_image: 'เพิ่มรูป',
	elements: 'องค์ประกอบ',
	intro_page_editor: 'การแก้ไขหน้าแนะนำ',
	unpublish_your_entitycover: 'ยกเลิกการเผยแพร่ส่วนแนะนำ{entityCover}',
	ebook_unpublish_message:
		'คุณแน่ใจว่าต้องการยกเลิกส่วนแนะนำ{entityCover}ของคุณ? <br />การปรับแต่งในส่วนแนะนำ{entityCover}จะไม่สามารถเข้าถึงได้เมื่อทำการยกเลิกการเผยแพร่',
	ebook_template_all_types: 'รวมไปถึงเนื้อหาในส่วนแนะนำของ{entity}',
	mobile_required: 'ต้องใช้มือถือ',
	financial_planning_ebook: 'อีบุ๊ค การวางแผนทางการเงิน',
	financial_planning_ebook_desc: 'กรอกข้อมูลของคุณและรับ อีบุ๊ค การวางแผนทางการเงินฟรี',
	email: 'อีเมล',
	email_required: 'จำเป็นต้องใช้อีเมลและต้องถูกต้อง',
	check_box_required: 'โปรดทำเครื่องหมายที่ช่องนี้หากต้องการดำเนินการต่อ',
	i_am_lisa: 'ฉันคือ ธนา สมบูรณ์',
	hello_i_am: 'สวีสดีฉันเอง FIRSTNAME LASTNAME',
	what_happy_clients_say: 'สิ่งที่ลูกค้ามีความสุขพูด',
	contact_me: 'ติดต่อฉัน',
	personal_wealth_manager: 'ผู้จัดการความมั่งคั่งส่วนบุคคล',
	tagline_no_br: 'สร้างความแตกต่างให้แก่อนาคตทางการเงิน',
	lets_talk: 'มาคุยกันเถอะ',
	drop_a_message: 'ส่งข้อความและรับการนัดหมายฟรีกับฉัน',
	financial_specialist: 'ผู้เชี่ยวชาญด้านการเงิน',
	phone: 'โทรศัพท์',
	customise_seo: 'ปรับแต่ง SEO',
	remove: 'ถอด',
	launch_successful: 'เปิดตัวสำเร็จ',
	congratulations_launched: 'ยินดีด้วย เปิดตัว {entity} ของคุณแล้ว!',
	congratulations_published: 'ขอแสดงความยินดี {entity} ของคุณได้รับการเผยแพร่แล้ว!',
	introduction_page: 'หน้าแนะนำตัว',
	report_editor: 'บรรณาธิการรายงาน',
	you_can_customize_section: 'คุณสามารถปรับแต่งรูปลักษณ์ของ {entityReportEbook} ได้ในส่วนนี้',
	settings_updated: 'อัปเดตการตั้งค่าแล้ว',
	contact_form_disclaimer: 'แบบฟอร์มการติดต่อปฏิเสธความรับผิดชอบ',
	preview_staging_environment_message:
		'คุณไม่สามารถส่งแบบฟอร์มการติดต่อในสภาพแวดล้อมการแสดงตัวอย่างหรือการแสดงละครได้',
	message_check_email_download_link: 'โปรดตรวจสอบอีเมลของคุณสำหรับลิงก์ดาวน์โหลด eBook',
	achievement1_title: 'มือใหม่ยอดนิยม',
	achievement1_position: 'ผู้ร่วมงาน',
	achievement1_description:
		'ฉันเริ่มต้นอาชีพที่ปรึกษาทางการเงินหลังจากใช้เวลา 4 ปีในโลกธุรกิจ ฉันรู้สึกว่าจำเป็นต้องเปลี่ยนแปลงและทำบางสิ่งที่มีความหมาย',
	achievement2_title: 'โต๊ะกลมล้านดอลลาร์ (MDRT)',
	achievement2_position: 'ผู้จัดการบริการทางการเงิน',
	achievement2_description:
		'ฉันรู้สึกตื่นเต้นมากเมื่อได้รับ MDRT เป็นปีแรก รางวัลนั้นมีค่าไม่มากแต่เป็นผลกระทบที่ฉันรู้สึกเมื่อเห็นลูกค้าบรรลุเป้าหมาย',
	achievement3_title: 'ศาลของโต๊ะ (COT)',
	achievement3_position: 'ผู้จัดการบริการทางการเงิน',
	achievement3_description:
		'มันเป็นเรื่องที่เหนือจริงเมื่อฉันได้ COT ครั้งแรกและช่วยผลักดันความปรารถนาของฉันในการช่วยให้ลูกค้าบรรลุเป้าหมายต่อไป',
	achievement4_title: 'Chartered Financial Planner (CFP)',
	achievement5_title: 'Chartered Financial Analyst (CFA)',
	achievement6_title: 'รางวัลมังกรนานาชาติ (IDA)',
	uploading: 'กำลังอัปโหลด...',
	compressing: 'กำลังบีบอัด...',
	navigation_button_color: 'ปุ่มนำทางสี',
	navigation_button_color_tooltip: 'หมายถึงสีของปุ่มลูกศร (เพื่อนำทางไปยังซ้ายและขวา)'
};
